import React, { useEffect, useState } from "react";
import { generatePageFormat } from "../utils/docUtil";
import { DocumentParameters } from "./DocumentParameters";
import { DocumentPreview } from "./DocumentPreview";

const standard = {
  fontFamily: "Helvetica",
};

export const PreviewPanel = ({ config, loadRules, preview, onClose }) => {
  const [rules, setRules] = useState(null);
  const [isOpen, setIsOpen] = useState(true);

  const [pageFormat, setPageFormat] = useState(
    generatePageFormat(config.paperFormat, config.orientation)
  );

  useEffect(() => {
    const fetchRules = async () => {
      try {
        const rulesData = await loadRules();
        console.log(
          "rules loaded",
          config.version,
          config.lang ?? "en",
          rulesData
        );
        setRules(rulesData);
      } catch (error) {
        console.error("Erreur lors du chargement des règles:", error);
      }
    };

    fetchRules();
    setPageFormat(generatePageFormat(config.paperFormat, config.orientation));
    document.documentElement.style.setProperty(
      "--padding-left-level",
      15 + config.textOffset / 2 + "px" || "25px"
    );
  }, [loadRules, config.version, config.lang]);

  if (!preview.visible) return null;

  return (
    <>
      {/* Paramètres du document */}
      <DocumentParameters
        config={config}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        onClose={onClose}
      />

      {/* Aperçu du document */}
      <DocumentPreview
        config={config}
        rules={rules}
        pageFormat={pageFormat}
        standard={standard}
      />
    </>
  );
};

export default PreviewPanel;
